var _circle, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAveragesignalstrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.91129,
    cy: 5.0878,
    r: 4.4628,
    stroke: "#5DA3E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.50586,
    y: 2.90015,
    width: 0.875,
    height: 4.375,
    rx: 0.4375,
    fill: "#5DA3E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81836,
    y: 3.77515,
    width: 0.875,
    height: 3.5,
    rx: 0.4375,
    fill: "#5DA3E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.13086,
    y: 4.65015,
    width: 0.875,
    height: 2.625,
    rx: 0.4375,
    fill: "#5DA3E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.44336,
    y: 5.52515,
    width: 0.875,
    height: 1.75,
    rx: 0.4375,
    fill: "#5DA3E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAveragesignalstrength);
export default __webpack_public_path__ + "static/media/Average signal strength.bc1f1cb61299f5cd7721f12a05c5d9f1.svg";
export { ForwardRef as ReactComponent };